import React from 'react';
import { uploadIcon } from '@chordbaker/design';

const UploadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={uploadIcon.viewBox}
    fill={uploadIcon.fill}
    stroke={uploadIcon.stroke}
    strokeWidth={uploadIcon.strokeWidth}
    strokeLinecap={uploadIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={uploadIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    {...props}
  >
    <path d={(uploadIcon.elements[0] as { d: string }).d} />
    <polyline points={(uploadIcon.elements[1] as { points: string }).points} />
    <line
      x1={(uploadIcon.elements[2] as { x1: number }).x1}
      y1={(uploadIcon.elements[2] as { y1: number }).y1}
      x2={(uploadIcon.elements[2] as { x2: number }).x2}
      y2={(uploadIcon.elements[2] as { y2: number }).y2}
    />
  </svg>
);

export default UploadIcon;
